var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[(_vm.url)?_c('div',{staticClass:"image-viewer",on:{"click":function($event){_vm.url = null}}},[_c('img',{staticClass:"mw-100 mh-100",attrs:{"src":_vm.url}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }